import {Form, message} from "antd";
import {useEffect} from "react";
import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {getEnums} from "@/services/homeService.ts";
import {useSetState} from "ahooks";
import {batchUpdateProductLibrary} from "@/services/product.ts";

const BelongProductLibraryModal = (props) => {
  const {open, onClose, ids, onReload} = props;
  const [form] = Form.useForm()
  const [state, setState] = useSetState<any>({
    productLibraryEnum: [],
    loading: false,
  })

  useEffect(() => {
    if (open) {
      getOptions()
      form.setFieldsValue({productLibrary: 'SOLUTION_LIBRARY'})
    }
  }, [open]);

  const getOptions = async() => {
    setState({loading: true})
    try {
      const productLibraryEnum = await getEnums('plus-product', 'com.shj.saas.plus.product.enums.ProductLibraryEnum');
      setState({productLibraryEnum: productLibraryEnum?.map(item => ({...item, label: item.description, value: item.key}))})
    } finally {
      setState({loading: false})
    }

  }

  const onFinish = () => {
    form.validateFields().then(values => {
      setState({loading: true})
      batchUpdateProductLibrary({ids, ...values}).then(res => {
        message.success(res.message || '操作成功');
        onClose?.()
        onReload?.()
      }).finally(() => {
        setState({loading: false})
      })
    })

  }

  return <>
    <SDrawerOrModal
      title={'所属产品库'}
      mode="modal"
      width={500}
      open={open}
      loading={state.loading}
      onCancel={onClose}
      onOk={onFinish}
    >
      <SGeneralForms
        formConfig={{form}}
        configs={[{
          formItem: [
            {
              spanCol: 24,
              label: '所属产品库',
              required: true,
              rules: [{ required: true, message: '所属产品库不能为空' }],
              name: 'productLibrary',
              type: 'radio',
              comConfig: {
                options: state.productLibraryEnum,
              },
            },
          ]
        }]}
      />
    </SDrawerOrModal>
  </>
}

export default BelongProductLibraryModal